import React, { Component } from 'react'

class ClickOutsideDecorator extends Component {

	constructor() {
		super()
		this.setElement = this.setElement.bind(this)
		this.setElementFunction = this.setElementFunction.bind(this)
		this.handleClick = this.handleClick.bind(this)
		this.refFunction = null
	}

	handleClick(ev) {
		if (this._element && !this._element.contains(ev.target) && this.props.clickOutsideHandler) {
			this.props.clickOutsideHandler()
			if (this.props.stopPropagation) {
				ev.stopImmediatePropagation()
			}
		}
	}

	componentDidMount() {
		document.addEventListener('click', this.handleClick, true)
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick)
	}

	setElement(_prevRef) {
		if (!this.refFunction) {
			this.refFunction = this.setElementFunction.bind(this, _prevRef)
		}
		return this.refFunction
	}

	setElementFunction(_prevRef, elem) {
		if (_prevRef) {
			_prevRef.call(null, elem)
		}
		this._element = elem
	}

	render() {
		const cloned = React.cloneElement(
			this.props.children,
			{
				ref: this.setElement(this.props.children.ref),
			}
		)
		return cloned
	}
}

ClickOutsideDecorator.defaultProps = {
	stopPropagation: false,
}

export default ClickOutsideDecorator
